import React from "react"

import Hero from "./Hero"
import WorkAtSaits from "components/WorkAtSaits"
import Clients from "./Clients"
import Services from "./Services"
import Contact from "components/Contact"
import CaseStudySection from "./CaseStudySection"
import AvailablePositions from "components/AvailablePositions"
import SaitsImage from "./SaitsImage"
import Footer from "components/Footer"
import CurveWrapper from "components/CurveWrapper"
import Chart from "./Chart"
import CaseStudyProvider from "components/CaseStudyProvider"
import AboutUs from "./AboutUs"

const LandingPage = () => (
  <main>
    <Hero />
    <Clients />
    <Services />
    <CaseStudyProvider
      render={caseStudies => {
        const caseStudy = caseStudies.find(x => x.company === "ESEN eSports")
        return <CaseStudySection caseStudy={caseStudy} bioWidth="65%" />
      }}
    />
    <Chart />
    <CaseStudyProvider
      render={caseStudies => {
        const caseStudy = caseStudies.find(x => x.company === "Learn2Esport")
        return <CaseStudySection caseStudy={caseStudy} bioWidth="65%" />
      }}
    />
    <AboutUs variant="light" />
    <Contact />
    <SaitsImage />
    <div id="work">
      <CurveWrapper direction="up">
        <WorkAtSaits variant="gray" />
      </CurveWrapper>
    </div>
    <AvailablePositions variant="light" />
    <Footer />
  </main>
)

export default LandingPage



// WEBPACK FOOTER //
// ./src/pages/LandingPage/index.jsx